export enum ErrorCode {
  TOKEN_EXPIRED = 'AUTH.TOKEN_EXPIRED',
  TOKEN_INVALID = 'AUTH.TOKEN_INVALID',
  USER_DISABLED = 'AUTH.USER_DISABLED',
  USER_NOT_AUTHENTICATED = 'AUTH.USER_NOT_AUTHENTICATED',

  // Access control errors
  USER_NOT_FOUND = 'ACCESS.USER_NOT_FOUND',
  DB_ACCESS_MISSING = 'ACCESS.DB_ACCESS_MISSING',
  ORG_ACCESS_MISSING = 'ACCESS.ORG_ACCESS_MISSING',

  NETWORK_OFFLINE = 'NETWORK.OFFLINE',
  NETWORK_TIMEOUT = 'NETWORK.TIMEOUT',

  UNEXPECTED = 'SYSTEM.UNEXPECTED',
  SMART_PASTE_ERROR = 'SYSTEM.SMART_PASTE_ERROR'
}
